export default __webpack_public_path__ + "static/media/green-ring.0ac97977.png";